export default __webpack_public_path__ + "static/media/a.a5407633.svg";